import React from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

export default function SponsorCarousel() {
  const { pathname } = useLocation();
  const isLanding = pathname === "/";
  const paddingClass = "pt-[80px]";

  return (
    <div className={`w-full bg-[#0B1429] overflow-hidden relative z-30 ${paddingClass}`}>
      <div className="relative flex overflow-x-hidden group mt-3">
        <motion.div 
          className="flex whitespace-nowrap w-max items-center"
          animate={{ x: ["0%", "-50%"] }}
          transition={{ repeat: Infinity, ease: "linear", duration: 30 }}
        >
          {/* We render a sequence of images and text blocks twice for a perfect seamless loop */}
          {["img", "text", "img", "text", "img", "img", "text", "img", "text", "img"].map((item, index) => (
            item === "img" ? (
              <div key={index} className="flex items-center shrink-0">
                <img src="/images/sponsor-strip.png" alt="Official Sponsors" className="h-8 md:h-11 object-contain w-auto max-w-none" />
              </div>
            ) : (
              <div key={index} className="flex items-center shrink-0 z-10 bg-white px-8 md:px-12 h-8 md:h-11">
                <span className="text-xs font-bold text-[#64748B] uppercase tracking-[0.25em] whitespace-nowrap">Official Sponsors</span>
              </div>
            )
          ))}
        </motion.div>
      </div>
    </div>
  );
}
